import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ColorPickerModule } from 'ngx-color-picker';

export type ColorSwatchPosition = 'top' | 'bottom' | 'left' | 'right';

@Component({
  selector: 'ptl-color-swatch',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ColorPickerModule],
  templateUrl: './ptl-color-swatch.component.html',
  styleUrls: ['./ptl-color-swatch.component.scss'],
})
export class PtlColorSwatchComponent {
  @Input() value: string;
  @Input() ariaLabel: string;
  @Input() position: ColorSwatchPosition = 'bottom';
  @Input() eyeDropper = false;

  @Output() valueChange = new EventEmitter<string>();

  onColorChange(color: string): void {
    this.value = color;
    this.valueChange.emit(color);
  }
}
